import React from 'react';
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import PatientsList from "../../containers/patients/PatientsList";
import UsersProvider from '../../store/users/usersProvider';

function PatientManager() {  
  
  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
    <UsersProvider>
      <PageWrapper navbar title='Patient Manager'>
        <PatientsList/>
      </PageWrapper>
    </UsersProvider>
  )
}

export default PatientManager;